import { formatPaise } from '../../../../lib/format.js';

/** Shared "discount summary" text builder for both `SpinOutcome` coupon
 * wins and `RewardCouponDto` cards -- keeps the percentage/fixed-amount
 * formatting logic in one place. */
export function formatDiscountSummary(coupon: {
  discountType: 'percentage' | 'fixed_amount';
  discountPercentBps: number | null;
  discountAmountPaise: number | null;
  maxDiscountPaise: number | null;
}): string {
  if (coupon.discountType === 'percentage') {
    const percent = coupon.discountPercentBps !== null ? coupon.discountPercentBps / 100 : null;
    const base = percent !== null ? `${percent}% off` : 'Percentage discount';
    return coupon.maxDiscountPaise !== null ? `${base} (up to ${formatPaise(coupon.maxDiscountPaise)})` : base;
  }
  return coupon.discountAmountPaise !== null ? `${formatPaise(coupon.discountAmountPaise)} off` : 'Fixed amount off';
}
